// removed by extract-text-webpack-plugin
module.exports = {"item":"mobileNavMenuBody__item__59a3c75c","sectionTitle":"mobileNavMenuBody__sectionTitle__59a3c75c","sectionItem":"mobileNavMenuBody__sectionItem__59a3c75c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/MobileNavMenu/mobileNavMenuBody.scss
// module id = ./src/components/MobileNav/MobileNavMenu/mobileNavMenuBody.scss
// module chunks = 4